import { type ReactNode } from 'react';
import { ComponentCreateRequestStatusCode } from '@gql/graphql';
import { useComponentCreateRequestStatusCounts } from '@hooks/NewComponentRequests/useComponentCreateRequestStatusCounts';
import { PillsSummary } from '@pages/notification-components/components/RequestsCard/RequestsHeader/components/PillsSummary';

export function RequestsHeader(): ReactNode {
    const { total, byStatus } = useComponentCreateRequestStatusCounts();

    return (
        <div className="flex flex-column gap-2">
            <h1>
                {byStatus[ComponentCreateRequestStatusCode.Approved]}/{total}
            </h1>
            <div className="flex align-items-center justify-content-between">
                <strong>Request approved</strong>
                <PillsSummary byStatus={byStatus} />
            </div>
        </div>
    );
}
